import {
  PermissionProp,
  ProfileContext,
} from "@/contexts/ProfileDetailsContext/Profile";
import { UserProps } from "@/contexts/ProfileDetailsContext/type";
import { redirect, useRouter, usePathname } from "next/navigation";
import React, {
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import UnauthorizedURL from "./UnauthorizedURL";
import UpshotLoader from "@/components/Common/Loader/Upshotloader";

/**
 *
 * @param roles if string then check this
 * @returns
 */
export default function WithAuth<T extends object>(
  roles: number | null | number[] = null,
  featurePermissions: PermissionProp | null = null,
  selectApp: boolean = true
) {
  const WithAuthWrapper = (WraperComponent: React.FC<T>) => {
    return function WithData(props: T) {
      const { user, loading, permissions, selectedApp } =
        useContext(ProfileContext);
      const router = useRouter(); // Using Next.js router for redirection
      const pathname = usePathname(); // Get current path
      const [checked, setChecked] = useState(false);

      // check that user has access to roles and feature permissions

      useEffect(() => {
        if (loading) {
          return;
        }

        if (!user) {
          router.push("/site/login"); // Only push to login if user is not authenticated
        } else {
          setChecked(true);
        }
      }, [loading]); // Dependency array ensures this runs only when user or loading changes

      const hasAccess = useMemo(() => {
        if (user && (roles || featurePermissions))
          return checkPermissions(
            roles || [],
            featurePermissions || {},
            user,
            permissions
          );
        return false;
      }, [user, permissions]);

      if (loading || !checked) {
        return <UpshotLoader />;
      } // if (!hasAccess) {
      //   return <UnauthorizedURL />;
      // }

      // if (selectApp && !selectedApp) {
      //   return <NoAppSelected />;
      // }
      return <WraperComponent {...(props || {})} />;
    };
  };
  return WithAuthWrapper;
}

const checkPermissions = (
  roles: number | number[],
  properties: PermissionProp,
  user: UserProps,
  permissions: PermissionProp
) => {
  const propertiesKeys: string[] = Object.keys(properties);

  for (let i = 0; i < propertiesKeys.length; i++) {
    const property = propertiesKeys[i];
    const permissionsToCheck = properties[property];
    const permissionsHas = permissions[property];
    let found = false;
    if (
      permissionsToCheck &&
      permissionsHas &&
      permissionsToCheck.every((val: number) => permissionsHas.includes(val))
    ) {
      found = true;
    }
    if (!found) {
      return false;
    }
  }
  return true;
};
